import React, { Component } from 'react';
import { TableHeaderColumn } from "react-bootstrap-table";

import Card from "Utils/Cards/Card";
import Header from "Utils/Grid/Header";
import Grid from "../../../Utils/Grid";
import { standardActions } from "../../../Utils/Grid/StandardActions";

export default class TiposMateriaPrima extends Component {
    componentWillMount() {
        const { listarPorProductoTerminado, page } = this.props;
        listarPorProductoTerminado(page, false);
    }

    render() {
        const { listarPorProductoTerminado, onSortChange, eliminar } = this.props;
        const { data, loader, page } = this.props;

        const handlePageChange = (page) => {
            listarPorProductoTerminado(page, false);
        };

        return (
            <div className="mb-4 col-12">
                <Card
                    icon="configuraciones_activo"
                    titulo="MATERIA PRIMA"
                    subtitulo="Del sistema"
                >
                    <Header to="materia_prima/crear" textBtn="CREAR MATERIA PRIMA" {...this.props} />
                    <Grid
                        page={page}
                        data={data}
                        loading={loader}
                        onPageChange={handlePageChange}
                        onSortChange={onSortChange}
                        hover
                        striped
                    >
                        <TableHeaderColumn
                            isKey
                            dataSort
                            dataField="id"
                            dataAlign="center"
                            width='20%'
                            dataFormat={standardActions({ editar: "materia_prima", eliminar })}
                        />
                        <TableHeaderColumn
                            dataField="tipo_materia_prima"
                            dataSort
                            width='20%'
                            dataFormat={cell => cell.nombre}
                        >
                            TIPO DE MATERIA PRIMA
                        </TableHeaderColumn>
                        <TableHeaderColumn
                            dataField="nombre"
                            dataSort
                            width='20%'
                        >
                            MATERIA
                        </TableHeaderColumn>
                        <TableHeaderColumn
                            dataAlign="left"
                            dataField="id"
                            width='20%'
                            dataSort
                        >
                            CÓDIGO
                        </TableHeaderColumn>
                        <TableHeaderColumn
                            dataAlign="left"
                            dataField="latex_contaminado"
                            dataFormat={cell => cell ? 'Materia para coágulo' : ''}
                            width='20%'
                            dataSort
                        >
                            ADICIONAL
                        </TableHeaderColumn>
                    </Grid>
                </Card>
            </div>
        );
    }
}
